// @flow

import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';
import { Section } from '@riseart/layout';
import { URL_PARTS, UrlTranslator } from 'shared_services/riseart/url/Translator';
import {
  filterSectionCls,
  filterSectionTopPaddedCls,
  filterSectionHashAnchorCls,
} from 'shared_components/common/filters/container/Section.less';

type Props = {
  children: Node,
  topPadded?: boolean,
  className?: string,
};

const HASH_FILTERS = Object.keys(UrlTranslator.translateTo('filters', URL_PARTS.HASH))[0];
/**
 * FilterSection
 *
 * @param {Props} props
 */
export const FilterSection = ({ children, topPadded, className, ...restProps }: Props): Node => (
  <Section
    background="gray"
    className={classNames(filterSectionCls, topPadded && filterSectionTopPaddedCls, className)}
    {...restProps}
  >
    <a name={HASH_FILTERS} className={filterSectionHashAnchorCls}>
      {' '}
    </a>
    {children}
  </Section>
);
